// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","BlueBar":"_2dlbji","BlueBarItem":"I7OufB","fadeInFrames":"_3CHcFq"};